<ncp-table #contacts [(options)]="options"></ncp-table>
